const TARGET_TYPES = {
  all: '',
  national_all: 'the President and U.S. Congress',
  congress: 'the U.S. Congress',
  senior: 'the U.S. Senate',
  junior: 'the U.S. Senate',
  senate: 'the U.S. Senate',
  house: 'the U.S. House of Representatives',
  president: 'the President',
  state_all: 'State Governors & Legislatures',
  governor: 'State Governors',
  state_legislature: 'State Legislatures',
  state_upper: 'State Senates',
  state_lower: 'State Legislatures',
  dnc: 'the Democratic National Committee',
  governor_senate: 'State Governors and the U.S. Senate',
  obama: 'President Obama',
  mayor: 'Mayors',
  ceo: 'State Election Officials',
};

const getTargetTypeHumanName = (abbreviation) => {
  const abbrev = abbreviation.toLowerCase();
  return TARGET_TYPES[abbrev] || '';
};

export default getTargetTypeHumanName;
